import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface NewsletterReward {
  enabled: boolean;
  discountPercentage: number | null;
}

@Injectable({ providedIn: 'root' })
export class NewsletterService {
  private readonly apiUrl = `${environment.baseUrl}/newsletter`;

  constructor(private readonly http: HttpClient) {}

  getReward(): Observable<NewsletterReward> {
    return this.http.get<NewsletterReward>(`${this.apiUrl}/reward`);
  }

  subscribe(email: string, consent: boolean): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/subscribe`, {
      email,
      consent,
    });
  }

  unsubscribe(token: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/unsubscribe`, {
      token,
    });
  }

  confirmSubscription(token: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/confirm`, {
      token,
    });
  }

  requestUnsubscribe(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/unsubscribe/request`, {
      email,
    });
  }
}
